import { render } from "./IconBrakeShoes.vue?vue&type=template&id=67dc23e2&lang=pug&bindings={\"id\":\"props\"}"
import script from "./IconBrakeShoes.vue?vue&type=script&lang=js"
export * from "./IconBrakeShoes.vue?vue&type=script&lang=js"
script.render = render

export default script